import { render, staticRenderFns } from "./AccessSettings.vue?vue&type=template&id=2bbc0a57&"
import script from "./AccessSettings.vue?vue&type=script&lang=js&"
export * from "./AccessSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports